import * as CommonMutations from '@/store/common/mutations.type'
import { AxiosResponse } from 'axios'
import Vue from 'vue'

// Получение списка для конкретного сотрудника (может быть админом, наблюдателем, сотрудником)
export const getIDPList = async ({commit, rootState}: any, user_id: string) => { 
  const response:AxiosResponse = await Vue.axios.get(`api/idp/list/${user_id}`)
  commit('common/'+CommonMutations.SET_ITEMS, { 
    state: rootState.idp,
    data: response.data.result || []
  }, {root: true})
}

export const finishTask = async ({commit, rootState}: any, data: {idp: string, task_id: string}) => {
  const response:AxiosResponse = await Vue.axios.post(`api/idp/finish_task`, data)
  if (response.data.result) {
    const { tasks, history } = response.data.result
    commit('common/'+CommonMutations.SET_ITEM, { 
      state: rootState.idp,
      data: {
        ...rootState.idp.item,
        tasks, 
        history
      }
    }, {root: true})
  }
  return response.data
}
